__turbopack_context__.v({
  "scrollToTop": "floating-actions-module__lC789q__scrollToTop",
  "stack": "floating-actions-module__lC789q__stack",
  "visible": "floating-actions-module__lC789q__visible",
  "whatsapp": "floating-actions-module__lC789q__whatsapp",
  "whatsappIcon": "floating-actions-module__lC789q__whatsappIcon",
});
